// 4993 A3 — Flex prompt after punch-out / manual add (WIT-GAP-FLEX-4993-002 §7 A3, D-FLEX2-4).
//
// The timer API answers a flex tenant's PATCH /hours/punch-in-out with 200 and a
// body, and POST /hours with 201 and the same shape under `data`:
//   { line_group, flex_prompt_required, overtime_minutes, flex_minutes,
//     supplement_minutes, lines: [{ id, start_date, end_date, amount, break,
//     net_minutes, overtime_rate, flex_choice }] }
// A legacy tenant keeps 204 (no body) / 201 { data: { id } }, so every helper
// here fails closed: no flag, no prompt.

function payloadOf (body) {
  if (!body || typeof body !== 'object') return null
  if (Object.prototype.hasOwnProperty.call(body, 'flex_prompt_required')) return body
  const data = body.data
  if (data && typeof data === 'object' && !Array.isArray(data)) return data
  return body
}

function toInt (value) {
  const n = parseInt(value, 10)
  return Number.isFinite(n) ? n : 0
}

function hoursToMinutes (value) {
  if (value === null || value === undefined || value === '') return 0
  const n = parseFloat(String(value).replace(',', '.'))
  return Number.isFinite(n) ? Math.round(n * 60) : 0
}

export function needsFlexPrompt (responseStatus, body) {
  if (responseStatus !== 200 && responseStatus !== 201) return false
  const payload = payloadOf(body)
  return Boolean(payload && payload.flex_prompt_required === true)
}

export function summarizePunchOut (body) {
  const payload = payloadOf(body) || {}
  return {
    lineGroup: payload.line_group || null,
    overtimeMinutes: toInt(payload.overtime_minutes),
    flexMinutes: toInt(payload.flex_minutes),
    supplementMinutes: toInt(payload.supplement_minutes),
    lines: Array.isArray(payload.lines) ? payload.lines : []
  }
}

// A4 — "Decide now" on one existing engine line: the whole net time is the
// overtime, the core hours go to flex and the supplement is rate % of them.
export function summarizeLine (line) {
  if (!line || typeof line !== 'object') return summarizePunchOut(null)
  const net = Number.isFinite(Number(line.net_minutes)) && line.net_minutes !== null && line.net_minutes !== ''
    ? toInt(line.net_minutes)
    : Math.max(0, hoursToMinutes(line.amount) - hoursToMinutes(line.break))
  const rate = toInt(line.overtime_rate)
  return {
    lineGroup: line.line_group || null,
    overtimeMinutes: net,
    flexMinutes: net,
    supplementMinutes: Math.round(net * rate / 100),
    lines: [line]
  }
}

export function formatMinutesHM (minutes) {
  const total = toInt(minutes)
  const sign = total < 0 ? '-' : ''
  const abs = Math.abs(total)
  const hours = Math.floor(abs / 60)
  const mins = abs % 60
  return `${sign}${hours}:${mins < 10 ? '0' : ''}${mins}`
}
